import * as React from 'react';

function SvgMessenger(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M10 1.459c4.829 0 8.571 3.537 8.571 8.314S14.83 18.087 10 18.087a9.348 9.348 0 01-2.481-.33.683.683 0 00-.458.034l-1.704.751a.686.686 0 01-.963-.606l-.046-1.525a.683.683 0 00-.23-.488 8.134 8.134 0 01-2.69-6.15c0-4.777 3.743-8.314 8.572-8.314zM4.853 12.204a.407.407 0 00.59.542l2.705-2.053a.516.516 0 01.62 0l2 1.5a1.285 1.285 0 001.857-.344l2.518-3.994a.407.407 0 00-.59-.541l-2.705 2.052a.516.516 0 01-.62 0l-2-1.5a1.286 1.286 0 00-1.857.344l-2.518 3.994z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgMessenger;
